import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { NotificationLog } from '@/models/notification.ts';

type NotificationStore = {
    notifications_by_user: {
        [key: string]: NotificationLog[];
    };
    addNotification: (user_email: string, notification: NotificationLog) => void;
    reset: () => void;
};

const initialState: { notifications_by_user: Record<string, NotificationLog[]> } = {
    notifications_by_user: {},
};

export const useNotificationStore = create<NotificationStore>()(
    persist(
        (set) => ({
            ...initialState,
            addNotification: (user_email: string, notification: NotificationLog): void =>
                set((state: NotificationStore) => ({
                    notifications_by_user: {
                        ...state.notifications_by_user,
                        [user_email]: [...(state.notifications_by_user[user_email] ?? []), notification],
                    },
                })),
            reset: (): void => set({ ...initialState }),
        }),
        {
            name: 'notification_store',
        }
    )
);
